import { combineReducers } from 'redux';

import authReducer from './auth.reducer';
import loadSettingsReducer from './loadSettings.reducer';
import settingsReducer from './settings.reducer';
import locationsReducer from './locations.reducer';

const appReducer = combineReducers({
  authState: authReducer,
  loadSettingsReducer: loadSettingsReducer,
  settings: settingsReducer,
  locations: locationsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'GLOBAL_CLEAR_STATE') {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
